import LogService from "../LogService";
import { projectLocation } from "../../utils/DeploymentSettings";
import { storage } from "../firebase/firebase";

class UploadService {
  static storageLocation = `${projectLocation}.appspot.com/`;
  static commentsLocation = `${projectLocation}-comments/`;
  static userDataLocation = `${projectLocation}-userdata/`;
  static assignmentLocation = `${projectLocation}-assignments/`;
  static readleeLibrary = `${projectLocation}-readleelibrary/`;

  static async uploadAudioData(data: Blob, location: string, duration: number) {
    const rootRef = storage.refFromURL(UploadService.storageLocation);

    try {
      await rootRef.child(location).put(data, {
        contentType: "audio/wav",
        customMetadata: {
          duration: duration.toString(),
          // sampleRate: '16000',
          // language: 'en-US',
          // encoding: 'LINEAR16'
        },
      });
    } catch (e) {
      LogService.exception(e, `UploadService.uploadAudioData`, "Failed to upload audio clip");
    }
  }

  static async uploadUserPicture(data: Blob, userId: string): Promise<string> {
    const rootRef = storage.refFromURL(UploadService.userDataLocation);
    const location = `${userId}/profile_pic/${Date.now()}`;

    try {
      const ref = rootRef.child(location);
      await ref.put(data);
      const downloadUrl = await ref.getDownloadURL();

      return downloadUrl;
    } catch (e) {
      LogService.exception(e, `UploadService.uploadUserPicture`, "Failed to upload user picture");

      throw e;
    }
  }
  //works for either epubs or pdfs, all depends on the path
  static async getLibraryBookDownload(path: string): Promise<string> {
    // TODO: Externalize this URL
    const root = storage.refFromURL(UploadService.readleeLibrary);

    const ref = root.child("/" + path);
    return (await ref.getDownloadURL()) as string;
  }

  // static async uploadEPUBToLibrary(data: Blob, isbn: string): Promise<string> {
  //   const rootRef = storage.refFromURL(UploadService.readleeLibrary);
  //   const location = `epubs/${isbn}/${Date.now()}.epub`;
  //   try {
  //     const ref = rootRef.child(location);
  //     const result = await ref.put(data);
  //     return location;
  //   } catch (e) {
  //     LogService.exception(e, `UploadService.uploadEPUBToLibrary`, "Failed to upload epub");
  //     throw e;
  //   }
  // }

  static async uploadPDFToLibrary(data: Blob, googleBookId: string): Promise<string> {
    const rootRef = storage.refFromURL(UploadService.readleeLibrary);
    const location = `pdfs/${googleBookId}/${Date.now()}.pdf`;
    try {
      const ref = rootRef.child(location);
      await ref.put(data);
      return location;
    } catch (e) {
      LogService.exception(e, `UploadService.uploadPDFToLibrary`, "Failed to upload pdf");
      throw e;
    }
  }

  static async uploadCommentAudioData(data: Blob, location: string, duration: number) {
    const _commentsStorageRecordingsRef = storage.refFromURL(UploadService.commentsLocation);

    try {
      await _commentsStorageRecordingsRef.child(location).put(data, {
        contentType: "audio/wav",
        customMetadata: {
          duration: duration.toString(),
          // sampleRate: '16000',
          // language: 'en-US',
          // encoding: 'LINEAR16'
        },
      });
    } catch (e) {
      LogService.exception(e, `UploadService.uploadCommentAudioData`, "Failed to upload audio clip");
    }
  }

  static async getCommentAudio(path: string): Promise<string> {
    // TODO: Externalize this URL
    const _commentsStorageRecordingsRef = storage.refFromURL(UploadService.commentsLocation);

    const ref = _commentsStorageRecordingsRef.child("/" + path);
    return (await ref.getDownloadURL()) as string;
  }

  static async getPageAudio(path: string, section: string): Promise<string> {
    const rootRef = storage.refFromURL(UploadService.storageLocation);

    try {
      return await rootRef.child("/" + path + "/" + section).getDownloadURL();
    } catch (err) {
      LogService.exception(err, `UploadService.getPageAudio`, "unable to get page audio");
    }
    return "";
  }

  static async getPdfPath(path: string): Promise<string> {
    const sections = path.split("/pdfs/");
    if (sections[0] && sections[1]) {
      const _commentsStorageRecordingsRef = storage.refFromURL(sections[0]);
      const ref = _commentsStorageRecordingsRef.child("/pdfs/" + sections[1]);
      return (await ref.getDownloadURL()) as string;
    }
    return "";
  }

  static async getCoverImagePath(path: string): Promise<string> {
    const sections = path.split("/coverImages/");
    if (sections[0] && sections[1]) {
      const _commentsStorageRecordingsRef = storage.refFromURL(sections[0]);

      const ref = _commentsStorageRecordingsRef.child("/coverImages/" + sections[1]);
      return (await ref.getDownloadURL()) as string;
    }
    return "";
  }
}

export default UploadService;
